import api from '../api';

export interface User {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  isActive: boolean;
  createdAt: string;
  lastLogin?: string;
}

export interface UserSimplified {
  id: string;
  email: string;
  name: string;
}

export const userService = {
  // Get all users (admins only)
  getAllUsers: async (): Promise<User[]> => {
    try {
      const response = await api.get('/users');
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter usuários:', error);
      throw error;
    }
  },

  // Get simplified user list (available to all users)
  getSimplifiedUsers: async (): Promise<UserSimplified[]> => {
    try {
      const response = await api.get('/users/simplified');
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter lista simplificada de usuários:', error);
      throw error;
    }
  },

  // Get user by ID
  getUserById: async (userId: string): Promise<User> => {
    try {
      const response = await api.get(`/users/${userId}`);
      return response.data.data;
    } catch (error) {
      console.error(`Erro ao obter usuário ${userId}:`, error);
      throw error;
    }
  },

  // Get user by email
  getUserByEmail: async (email: string): Promise<User> => {
    try {
      const response = await api.get(`/users/by-email/${email}`);
      return response.data.data;
    } catch (error) {
      console.error(`Erro ao obter usuário pelo email ${email}:`, error);
      throw error;
    }
  }
};
